import create from 'zustand';

export enum ModalNames {
  COMPOSE_ERROR_LINK = 'COMPOSE_ERROR_LINK',
  SECURITIES_REGISTER = 'SECURITIES_REGISTER',
  STREAM_POST_LIMIT = 'STREAM_POST_LIMIT',
}

interface ModalState {
  activeModal: ModalNames | null;
  title: string;
  openModal: (modalName: ModalNames, title?: string) => void;
  closeModal: () => void;
}

const useModalStore = create<ModalState>((set) => ({
  activeModal: null,
  title: '',
  openModal: (modalName, title = '') => set({ activeModal: modalName, title }),
  closeModal: () => set({ activeModal: null, title: '' }),
}));

export default useModalStore;
